import { render, staticRenderFns } from "./MyUploadList.vue?vue&type=template&id=5563f985&scoped=true&"
import script from "./MyUploadList.vue?vue&type=script&lang=js&"
export * from "./MyUploadList.vue?vue&type=script&lang=js&"
import style0 from "./MyUploadList.vue?vue&type=style&index=0&id=5563f985&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563f985",
  null
  
)

export default component.exports